import { render } from "./FooterSave.vue?vue&type=template&id=3d20c05b&scoped=true"
import script from "./FooterSave.vue?vue&type=script&lang=js"
export * from "./FooterSave.vue?vue&type=script&lang=js"

import "./FooterSave.vue?vue&type=style&index=0&id=3d20c05b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3986129723/src/app-csd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d20c05b"]])

export default __exports__